import { render, staticRenderFns } from "./ChildItem.vue?vue&type=template&id=fdd8ca9a&scoped=true&"
import script from "./ChildItem.vue?vue&type=script&lang=js&"
export * from "./ChildItem.vue?vue&type=script&lang=js&"
import style0 from "./ChildItem.vue?vue&type=style&index=0&id=fdd8ca9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd8ca9a",
  null
  
)

export default component.exports